module.exports = __webpack_public_path__ + "img/basic-reading.9020ff5f.svg";